/* CX Engagement v3 — CX-branded tab titles + exit-intent popup (no favicon badge) */
(function(){
  'use strict';
  if (window.__cxEngagement) return; window.__cxEngagement = true;

  /* ============ Tab title switcher ============ */
  var originalTitle = document.title;
  var restoreTimer = null;
  var EMPTY = [
    'CX · ¿Volvés? 👀',
    'CX te espera 🧡',
    '¡Volvé a CX! ✨'
  ];
  var WITH_CART = [
    'CX · Tu carrito te extraña 🛒',
    'CX · Tu pedido espera 💛',
    'CX · 🛍️ Productos esperando'
  ];
  var WELCOME = '¡Hola de nuevo en CX! 💛';

  function hasCart(){
    try {
      var n = 0;
      var b1 = document.getElementById('cbCartBadge');
      var b2 = document.getElementById('cartFabBadge');
      if (b1 && !b1.hidden) n = Math.max(n, parseInt(b1.textContent||'0',10)||0);
      if (b2 && !b2.hidden) n = Math.max(n, parseInt(b2.textContent||'0',10)||0);
      return n > 0;
    } catch(e){ return false; }
  }
  function pickMsg(){
    var pool = hasCart() ? WITH_CART : EMPTY;
    return pool[Math.floor(Math.random()*pool.length)];
  }

  document.addEventListener('visibilitychange', function(){
    if (document.hidden) {
      if (restoreTimer) { clearTimeout(restoreTimer); restoreTimer = null; }
      document.title = pickMsg();
    } else {
      if (restoreTimer) clearTimeout(restoreTimer);
      document.title = WELCOME;
      restoreTimer = setTimeout(function(){
        document.title = originalTitle;
        restoreTimer = null;
      }, 1800);
    }
  });

  /* If page navigates while visible, refresh baseline title */
  var titleEl = document.querySelector('title');
  if (titleEl && window.MutationObserver) {
    new MutationObserver(function(){
      if (!document.hidden && !restoreTimer) originalTitle = document.title;
    }).observe(titleEl, { childList: true, characterData: true, subtree: true });
  }

  /* ============ Exit-intent popup ============ */
  var popup = document.getElementById('cxExitPopup');
  if (!popup) return;
  var KEY = 'cx_exit_shown_at';
  var COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;
  function isShown(){
    try {
      var ts = parseInt(localStorage.getItem(KEY) || '0', 10);
      return ts && (Date.now() - ts < COOLDOWN_MS);
    } catch(e){ return false; }
  }
  function markShown(){ try { localStorage.setItem(KEY, String(Date.now())); } catch(e){} }

  var armed = false;
  setTimeout(function(){ armed = true; }, 4000);

  function openPopup(){
    if (!armed || isShown() || !hasCart()) return;
    popup.removeAttribute('hidden');
    requestAnimationFrame(function(){ popup.classList.add('is-open'); });
    markShown();
    document.body.style.overflow = 'hidden';
  }
  function closePopup(){
    popup.classList.remove('is-open');
    setTimeout(function(){
      popup.setAttribute('hidden','');
      document.body.style.overflow = '';
    }, 260);
  }

  document.addEventListener('mouseout', function(e){
    if (e.relatedTarget || e.toElement) return;
    if (e.clientY > 10) return;
    openPopup();
  });

  /* Removed mobile popstate hijack (was breaking the Back button — confirmed via Clarity quick-back 33%) */

  popup.addEventListener('click', function(e){
    var t = e.target;
    while (t && t !== popup) {
      if (t.matches && t.matches('[data-cx-close]')) { closePopup(); return; }
      t = t.parentNode;
    }
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });
})();
